<p-badge
  [value]="value"
  [badgeSize]="badgeSize"
  [severity]="severity"
></p-badge>
